import React, { Fragment, useState, useEffect } from 'react';
import { Modal, Checkbox, Input, Tag, Divider, Button, Row, Col } from 'antd';

const { Search } = Input;

export default (props) => {
	const { visible, setVisible, curProduct, handleSelectImei } = props;

	const [selectedImeis, setSelectedImeis] = useState([]); // array of string (imei)
	const [searchText, setSearchText] = useState('');
	const [filteredImeis, setFilteredImeis] = useState([]);

	useEffect(() => {
		if (visible) {
			setSelectedImeis(curProduct?.imeiListRefund || []);
			setSearchText('');
			setFilteredImeis(curProduct?.imeiList || []);
		}
	}, [visible, curProduct]);

	useEffect(() => {
		onFilter();
	}, [searchText, curProduct]);

	const onFilter = () => {
		const allImeis = curProduct?.imeiList || [];
		const filtered = allImeis.filter(el => {
				if (searchText === '') {
					return true;
				} else {
					return el.imei.toLowerCase().includes(searchText.trim().toLowerCase()) && !selectedImeis.includes(el.imei);
				}
			}
		);
		setFilteredImeis(filtered);
	};

	const handleOk = () => {
		handleSelectImei(selectedImeis);
		setVisible(false);
	};

	const handleCancel = () => {
		setVisible(false);
	};

	const onCheckboxChange = (checkedValues) => {
		if (searchText === '') {
			setSelectedImeis(checkedValues); // array of imei strings
		} else {
			setSelectedImeis([...selectedImeis, ...checkedValues]);
		}
	};

	const onSearchChange = (e) => {
		setSearchText(e.target.value);
	};

	const getImeiLabel = (imei) => {
		const found = curProduct?.imeiList?.find(item => item.imei === imei);
		return found?.imei || imei;
	};

	return (
		<Fragment>
			<Modal
				width={800}
				title={`Danh sách Serial của sản phẩm ${curProduct?.productName || ''}`}
				visible={visible}
				onOk={handleOk}
				onCancel={handleCancel}
			>
				{/* Tìm kiếm */}
				<Search
					placeholder="Tìm kiếm IMEI..."
					value={searchText}
					onChange={onSearchChange}
					allowClear
					style={{ marginBottom: 12 }}
				/>

				{/* Danh sách IMEI đã chọn */}
				<div style={{ marginBottom: 12 }}>
					<Row>
						<Col span={20} style={{ marginBottom: 12 }}>
							<i>IMEI đã chọn ({selectedImeis.length}):</i>
						</Col>
						<Col span={4} style={{ textAlign: 'right' }}>
							<Button type={'link'} onClick={() => {
								if (selectedImeis.length === curProduct?.imeiList?.length) {
									setSelectedImeis([]);
								} else {
									setSelectedImeis(curProduct?.imeiList?.map(el => el.imei) || []);
								}
							}}>{selectedImeis.length !== curProduct?.imeiList?.length ? 'Chọn tất cả' : 'Bỏ chọn tất cả'}</Button>
						</Col>
					</Row>
					<div
						style={{
							display: 'flex',
							flexWrap: 'wrap',
							gap: 8,
							marginTop: 4,
							maxHeight: 100,
							overflowY: 'auto'
						}}
					>
						{selectedImeis.map(imei => (
							<Tag
								key={imei}
								closable
								onClose={() => {
									setSelectedImeis(prev => prev.filter(i => i !== imei));
									// setTimeout(() => {
									// 	onFilter();
									// }, 100);
								}}
								color={imei === searchText?.trim() ? 'blue' : ''}
								title={imei}
								style={{
									maxWidth: '150px',
									overflow: 'hidden',
									textOverflow: 'ellipsis',
									whiteSpace: 'nowrap'
								}}
							>
								{getImeiLabel(imei)}
							</Tag>
						))}
					</div>
					<Divider style={{ margin: '12px 0' }} />
				</div>

				{/* Danh sách checkbox IMEI */}
				<Checkbox.Group
					value={selectedImeis}
					onChange={onCheckboxChange}
					style={{
						display: 'flex',
						flexWrap: 'wrap',
						gap: 8,
						maxHeight: 300,
						overflowY: 'auto'
					}}
				>
					{filteredImeis.length > 0 ? (
						filteredImeis.map(el => (
							<Checkbox style={{
								marginLeft: 0,
								width: '45%',
								paddingLeft: 10
							}} key={el.id || el.imei} value={el.imei}>
								{el.imei}
							</Checkbox>
						))
					) : (
						<div style={{ color: '#888', textAlign: 'center' }}>Không tìm thấy IMEI nào</div>
					)}
				</Checkbox.Group>
			</Modal>
		</Fragment>
	);
};
